import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { getAuthSlice } from "../../../application/selectors/auth";
import {
  getAccessToken,
  getRefreshToken,
  isAccessTokenExpired,
  readStoredUser,
} from "../../../infrastructure/utils/authSession";

const PrivateRoute = ({ children }) => {
  let location = useLocation();
  const { isLoggedIn } = useSelector(getAuthSlice);
  const user = readStoredUser();
  const hasAccessToken = Boolean(getAccessToken(user));
  const hasRefreshToken = Boolean(getRefreshToken(user));
  const canStaySignedIn =
    isLoggedIn &&
    (hasRefreshToken || (hasAccessToken && !isAccessTokenExpired(user)));

  if (!canStaySignedIn) {
    localStorage.removeItem("user");

    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;
